export default [
  {
    path: '*',
    name: 'QuicklyWarranty',
    meta: {
      title: '质保查询'
    },
    component: () => import('@/views/home')
  }, {
    path: '/query',
    name: 'QueryQuicklyWarranty',
    meta: {
      title: '质保查询'
    },
    component: () => import('@/views/query')
  }, {
    path: '/create',
    name: 'CreateQuicklyWarranty',
    meta: {
      title: '快速质保'
    },
    component: () => import('@/views/create')
  }, {
    path: '/warranty-list',
    name: 'QuicklyWarrantyList',
    meta: {
      title: '质保列表'
    },
    component: () => import('@/views/warranty-list')
  }, {
    path: '/warranty-detail',
    name: 'QuicklyWarrantyDetail',
    meta: {
      title: '质保详情'
    },
    component: () => import('@/views/warranty-detail')
  }, {
    path: '/apply',
    name: 'ApplyQuicklyWarranty',
    meta: {
      title: '快速质保'
    },
    component: () => import('@/views/apply')
  }
]